import { defineStore } from 'pinia'
import { generatePaginatedStore } from '../pinia/utils/createCrudStore'
import type { Genre } from '~~/types'

const { state, getters } = generatePaginatedStore({ pageSize: 100, apiResource: 'Genres' })

type Nullable<T> = T | null

interface GenreStore {
	items: Genre[]
	selectedSearchFilters: {
		language: string[]
		genre: string[]
		sort: string
		has_cover: boolean
		has_plus: boolean
		has_duet: boolean
		has_explicit: boolean
		has_original: boolean
	}
	loading: boolean
	error: any
	page: number
	pageSize: number
	nextPage: Nullable<string>
}

export const useGenreStore = defineStore('genreStore', {
	state: (): GenreStore => ({
		...state,
		selectedSearchFilters: {
			language: [],
			genre: [],
			sort: '',
			has_cover: false,
			has_plus: false,
			has_duet: false,
			has_explicit: false,
			has_original: false
		}
	}),
	getters: {
		allGenres: state => state.items,
		...getters
	},
	actions: {
		hydrateGenres(genres: Genre[]) {
			this.items = genres
		},
		setNextPage(nextPage: Nullable<string>) {
			this.nextPage = nextPage
		},
		addToSelectedFilter(filterGroup: any, filter: any) {
			(this.selectedSearchFilters[filterGroup as keyof object] as any) = filter
		},
		clearAllFilters() {
			this.selectedSearchFilters = {
				language: [],
				genre: [],
				sort: '',
				has_cover: false,
				has_plus: false,
				has_duet: false,
				has_explicit: false,
				has_original: false
			}
		}
	}
})
